/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable @typescript-eslint/indent */
/* eslint-disable no-undef */
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Dialog } from '@pwskills/rachnaui';
import { useUTMParameters } from '@pwskills/rachnaui/hooks';
import usePostLoginRedirection from '@/hooks/usePostLoginRedirection';
// import { useRouter } from 'next/router';
// import useIsCourseBought from '@/hooks/useIsCourseBought';
import AuthApi from '@/api/auth';
// import { useAuthentication, CircleLoader } from '@pwskills/auth';
import useIsCourseBought from '@/hooks/useIsCourseBought';
import { getTokenFromLocalStorage, updateUserInLocalStorage } from '@/utils/helper/helperFunction';
import { domainNameEnums, saasDomains } from '@/utils/Domain';
import LSQApi from '@/api/lsq';
import { buildLSQOnboardingFormPayload } from '@/utils/lsq/lsqHelpers';
import { domainName, s3Url } from '../../../utils/common/env.constants';
import moEvent from '../../../utils/moEngage';
import LeadCaptureApi from '../../../api/leadCapture';
import CourseDescriptionContext from '../../../context/CourseDescriptionContext';
import { LeadCaptureType, LeadType, ModalType } from '../../../interfaces/leadCapture.enum';

import { IError, IUserPreferences } from '../../../interfaces/common';
import CategoryPageContext from '../../../context/CategoryPageContext';
import { OnboardingLeadFormProps } from '../../../interfaces/leadCapture';
import { GAevent } from '../../../utils/firebase.utils';
import { sendSkFormStartedEvent, sendSkFormSubmittedEvent } from '../../../utils/GAEventFunction';
import useUserDetails from '../../../store/userDetails';
import Saving from '../LeadForm/Saving';
import Modal from '../Modal';
import OnboardingForm from '../OnboardingForm';
import CircleLoader from '../OnboardingForm/CircleLoader';

type ContactDetails = {
  fullName: string;
  email?: string;
  isdCode: string;
  phoneNumber: string;
  source?: string;
  medium?: string;
  campaign?: string;
  category_name?: string;
};

// type Error = { nameError: boolean; emailError: boolean; phoneNumberError: boolean };

const AUTO_CLOSE_TIME = 5000;

const OnboardingLeadForm = ({
  leadCaptureType,
  modalOpen,
  setModalOpen,
  // buttonText,
  modalType,
  type,
  redirectLink,
  courseId,
  categoryId,
  courseName,
  collegeName,
  categoryName,
  enquiryType,
  enquiryTypeNPF,
  msgLineOne,
  msgLineTwo,
  curriculumPdf,
  reportLink,
  pageName,
  redirectToDashboard,
  source,
  onSuccessCallback,
}: OnboardingLeadFormProps) => {
  // const { user, isLoggedIn } = useContext(UserDetailsContext);
  const { userDetails: user, setUserDetails, setShowOnboarding } = useUserDetails();
  const { goToDashoboard } = usePostLoginRedirection();
  const isToken = getTokenFromLocalStorage();
  const isLoggedIn = Boolean(
    isToken && isToken !== 'undefined' && isToken !== 'null' && isToken !== ''
  );
  const utmQuery = useUTMParameters();
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const [openOnboardingForm, setOpenOnboardingForm] = useState<boolean>(modalOpen);
  // const [showOnboardingForm , setOpenOnboardingForm] = useState<boolean>(false);
  const downloadDirectly = isLoggedIn && modalType === ModalType.ONBOARDING;
  const { checkIsCourseBought } = useIsCourseBought();

  const anchorRef = useRef<HTMLAnchorElement | null>(null);
  const [saving, setSaving] = useState<boolean>(false);
  const { courseDetails } = useContext(CourseDescriptionContext);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const [isCourseBought, setIsCourseBought] = useState<boolean>(false);
  const { categoryDetails } = useContext(CategoryPageContext);
  const [loading, setLoading] = useState<boolean>(false);
  const [loadingDashboarding, setLoadingDashboarding] = useState<boolean>(false);
  const [count, setCount] = useState(AUTO_CLOSE_TIME / 1000);
  const hasDownloadedRef = useRef(false);
  const skFormStartedTrackedRef = useRef(false);

  const getUserPseudoId = () => {
    if (typeof document === 'undefined') return null;
    const gaCookie = document.cookie.split('; ').find((row) => row.startsWith('_ga='));
    if (!gaCookie) return null;
    const gaParts = gaCookie.split('.');
    if (gaParts.length > 2) {
      return `${gaParts[2]}.${gaParts[3]}`;
    }
    return null;
  };

  const getUserSegmentForAnalytics = () => {
    if (isLoggedIn) {
      return 'returning_user';
    }
    return 'new';
  };

  const getCourseContextForEvent = () => {
    const derivedCourseName =
      courseName || courseDetails?.name || courseDetails?.title || categoryDetails?.title || '';
    const derivedCourseId = courseId || courseDetails?._id || '';
    const derivedCategoryName =
      categoryName || courseDetails?.categoryDetails?.title || categoryDetails?.title || '';
    const cohortId =
      typeof courseDetails?.cohortId === 'string'
        ? courseDetails?.cohortId
        : courseDetails?.cohortId?._id || '';
    const courseSlug = courseDetails?.slug || '';
    const price = courseDetails?.pricing?.IN ?? courseDetails?.pricing?.US;
    const discount = courseDetails?.pricing?.discount;
    const isFree = courseDetails?.pricing?.isFree;

    return {
      courseNameValue: derivedCourseName,
      courseIdValue: derivedCourseId,
      courseCategoryValue: derivedCategoryName,
      cohortIdValue: cohortId,
      courseSlugValue: courseSlug,
      priceValue: price,
      discountValue: discount,
      isFreeValue: isFree,
    };
  };

  const triggerSkFormSubmittedEvent = (preferences?: IUserPreferences) => {
    if (!preferences) return;

    const backgroundValue =
      preferences.background?.title || user?.profileId?.userPreferences?.background?.title || '';
    const courseInterestValue =
      preferences.interestedCourse?.title ||
      user?.profileId?.userPreferences?.interestedCourse?.title ||
      '';
    const domainValue =
      preferences.interestedDomain?.title ||
      user?.profileId?.userPreferences?.interestedDomain?.title ||
      '';
    const {
      courseNameValue,
      courseIdValue,
      courseCategoryValue,
      cohortIdValue,
      courseSlugValue,
      priceValue,
      discountValue,
      isFreeValue,
    } = getCourseContextForEvent();
    const pagePath = typeof window !== 'undefined' ? window.location.pathname : pageName || '';
    const formLocation = pageName || 'onboarding_lead_form';
    const pageReferrerCta = type || enquiryType || 'onboarding_lead_form_submit';
    const widgetName = modalType || 'onboarding_lead_form_modal';
    const sanitizedName = `${user?.firstName || ''} ${user?.lastName || ''}`.trim();
    const sanitizedEmail = (user?.email || '').trim();
    const phoneNumber = (user?.primaryNumber || user?.phoneNumber || '') as string;
    const sanitizedPhoneNumber = typeof phoneNumber === 'string' ? phoneNumber.trim() : '';
    const phoneCode = (user?.isdCode || user?.countryCode || '') as string;
    const sanitizedPhoneCode = typeof phoneCode === 'string' ? phoneCode.trim() : '';

    sendSkFormSubmittedEvent({
      userData: user,
      isLoggedIn,
      isUserPaid: isCourseBought,
      user_account_type: user?.userType,
      page_path: pagePath,
      page_referrer_name: pageName || undefined,
      page_referrer_cta: pageReferrerCta,
      page_referrer_widget_name: widgetName,
      user_pseudo_id: getUserPseudoId() || undefined,
      pw_user_id: user?._id,
      user_segment: getUserSegmentForAnalytics(),
      form_id: 'onboarding_lead_form',
      form_name: 'login form',
      form_type: 'lead',
      form_location: formLocation,
      form_total_fields: 3,
      background: backgroundValue || undefined,
      course_of_interest: courseInterestValue || undefined,
      domain: domainValue || undefined,
      course_name: courseNameValue || undefined,
      course_category: courseCategoryValue || undefined,
      course_id: courseIdValue || undefined,
      course_slug: courseSlugValue || undefined,
      cohort_id: cohortIdValue || undefined,
      price: priceValue,
      discount: discountValue,
      is_free: isFreeValue,
      user_name: sanitizedName || undefined,
      user_email: sanitizedEmail || undefined,
      user_phone_number: sanitizedPhoneNumber || undefined,
      user_phone_isd_code: sanitizedPhoneCode || undefined,
      name: sanitizedName || undefined,
      email: sanitizedEmail || undefined,
      phone_number: sanitizedPhoneNumber || undefined,
    });
  };

  const checkIfPresenceAlreadyFilled = () => {
    if (saasDomains.includes(domainName as domainNameEnums)) return true;
    if (
      user?.profileId?.userPreferences?.interestedDomain?.title &&
      user?.profileId?.userPreferences?.interestedDomain?.title !== ''
    ) {
      return true;
    }
    return false;
  };

  const showOnboardingForm = isLoggedIn && !checkIfPresenceAlreadyFilled();

  const closeModal = () => {
    setSaving(false);
    setModalOpen(false);
    if (loading) {
      setLoading(false);
      // setOpenOnboardingForm(false);
    }
    if (setDialogOpen) {
      setDialogOpen(false);
    }
    if (onSuccessCallback) {
      onSuccessCallback();
    }
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    if (isLoggedIn) {
      setCount(AUTO_CLOSE_TIME / 1000);
    }
  };

  function getEventDataObj(data: ContactDetails, eventType: string) {
    const commonData = {
      user_id: user?._id || '',
      user_type: isLoggedIn ? 'loggedin' : 'not_loggedin',
      course_status: isLoggedIn && isCourseBought ? 'purchased' : 'not_purchased',
      enquiry_type: enquiryType,
      ...(eventType === 'MO' && {
        phone_number: data.phoneNumber || '',
        username: `${user?.firstName} ${user?.lastName}` || '',
        ...(user?.verified && user?.email && { email: user.email }),
      }),
      ...(modalType === ModalType.ONLINE_DEGREE && {
        // student_background: selectedBackground,
        // work_experience: selectedWorkExperience,
        courseType: 'online degree',
      }),
      ...(eventType === 'GA' && {
        page_name: pageName,
        form_id:
          leadCaptureType === LeadCaptureType.FORM
            ? `${enquiryType}_form_input_field`
            : `${enquiryType}_form`,
      }),
    };

    if (leadCaptureType === LeadCaptureType.MODAL) {
      return {
        ...commonData,
        course_name: courseName || (courseDetails && (courseDetails?.name || courseDetails?.title)),
        course_id: courseId || (courseDetails && courseDetails._id),
        category_name: categoryName || (courseDetails && courseDetails?.categoryDetails?.title),
        category_id: categoryId || (courseDetails && courseDetails?.categoryDetails?._id),
      };
    }
    return {
      ...commonData,
      course_name: '',
      course_id: '',
      category_name: categoryDetails?.title,
      category_id: categoryDetails?._id,
    };
  }

  function getObjDataDb(data: any) {
    const dbData = {
      ...(isLoggedIn && { user_id: user?._id }),
      user_type: isLoggedIn ? ('logged_in' as const) : ('logged_out' as const),
      phone_number: user.phoneNumber || '',
      username: `${user?.firstName} ${user?.lastName}` || '',
      student_background:
        data?.profileId?.userPreferences?.background?.title ||
        user?.profileId?.userPreferences?.background.title ||
        '',
      domain_interest:
        data?.profileId?.userPreferences?.interestedCourse.title ||
        user?.profileId?.userPreferences?.interestedCourse.title ||
        '',
      category_name:
        data?.profileId?.userPreferences?.interestedDomain.title ||
        user?.profileId?.userPreferences?.interestedDomain.title ||
        '',
      ...(user?.verified && user?.email && { email: user.email }),
      ...(modalType === ModalType.ONLINE_DEGREE &&
        {
          // background: selectedBackground,
          // experience: selectedWorkExperience,
        }),
      page_name: pageName,
      date_time: new Date().toISOString(),
    };

    return {
      ...dbData,
      course_name: courseName || (courseDetails && (courseDetails?.name || courseDetails?.title)),
      course_id: courseDetails && courseDetails._id,
      // category_name: courseDetails && courseDetails?.categoryDetails?.title,
      category_id: courseDetails && courseDetails?.categoryDetails?._id,
      enquiry_type: enquiryTypeNPF,
    };
  }

  const sendDataToDB = async (data: any) => {
    const objData = getObjDataDb(data);
    try {
      await LeadCaptureApi.sendDataToDatabase(objData);
    } catch (error: unknown) {
      // eslint-disable-next-line no-console
      console.error((error as IError)?.error);
    }
  };

  const handleGAEvent = (data: any) => {
    const GAEventDataObj = {
      user_id: user?._id,
      user_type: 'loggedin',
      user_category: user?.userType || '',
      student_background: data?.profileId?.userPreferences?.background?.title,
      student_interest: data?.profileId?.userPreferences?.interestedCourse?.title,
      category_name: data?.profileId?.userPreferences?.interestedDomain?.title,
      enquiryType: enquiryType || '',
      method: isLoggedIn ? 'otp' : '',
      source: source || '',
      page_name: pageName,
      utm_source: utmQuery?.utm_source || '',
      utm_medium: utmQuery?.utm_medium || '',
      utm_campaign: utmQuery?.utm_campaign || '',
    };
    GAevent('sk_form_submit', GAEventDataObj);
  };

  const sendMoengageEvent = (data: any) => {
    const moEventDataObj = {
      user_id: user?._id,
      user_mobile: user?.primaryNumber,
      last_name: user?.lastName || '',
      first_name: user?.firstName || '',
      email: user?.email || '',
      username: `${user?.firstName} ${user?.lastName}`,
      student_background: data?.profileId?.userPreferences?.background?.title,
      student_interest: data?.profileId?.userPreferences?.interestedCourse?.title,
      category_name: data?.profileId?.userPreferences?.interestedDomain?.title,
    };
    moEvent('onboarding_form_submit', moEventDataObj);
  };

  const sendEventToBackend = async (userPreferences: IUserPreferences, queryString: string) => {
    await LeadCaptureApi.sendEventDataToBackend(userPreferences, queryString);
  };

  const sendLead = async (data: any) => {
    let queryString = '';
    const GAEventDataObj = getEventDataObj(data, 'GA');
    sendDataToDB(GAEventDataObj);
    handleGAEvent(data);
    sendMoengageEvent(data);
    try {
      const submittedPreferences = data?.userPreferences;
      const storedPreferences = user?.profileId?.userPreferences;
      const lsqPayload = buildLSQOnboardingFormPayload({
        userId: user?.id || '',
        name: `${user?.firstName || ''} ${user?.lastName || ''}`.trim(),
        mobile: user?.phoneNumber || user?.primaryNumber || '',
        email: user?.email || '',
        utmSource: utmQuery?.utm_source,
        utmMedium: utmQuery?.utm_medium,
        utmCampaign: utmQuery?.utm_campaign,
        studentBackground:
          submittedPreferences?.background?.title || storedPreferences?.background?.title || '',
        studentInterest:
          submittedPreferences?.interestedCourse?.title ||
          storedPreferences?.interestedCourse?.title ||
          '',
        batchId:
          submittedPreferences?.interestedDomain?._id ||
          submittedPreferences?.interestedDomain?.categoryId ||
          storedPreferences?.interestedDomain?._id ||
          storedPreferences?.interestedDomain?.categoryId ||
          '',
        batchName:
          submittedPreferences?.interestedDomain?.title ||
          storedPreferences?.interestedDomain?.title ||
          '',
        state: user?.profileId?.state,
        city: user?.profileId?.city,
      });
      LSQApi.sendLead(lsqPayload);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('LSQ Onboarding Form Submission event failed:', error);
    }

    try {
      /* query string for utm params  currently not handling npf events so commenting it */
      const queryParams = [];
      if (data.query.source) queryParams.push(`source=${encodeURIComponent(data.query.source)}`);
      if (data.query.medium) queryParams.push(`medium=${encodeURIComponent(data.query.medium)}`);
      if (data.query.campaign)
        queryParams.push(`campaign=${encodeURIComponent(data.query.campaign)}`);
      if (data.query.enquiryType)
        queryParams.push(`enquiryType=${encodeURIComponent(data.query.enquiryType)}`);
      if (data.query.field_course_new)
        queryParams.push(`field_course_new=${encodeURIComponent(data.query.field_course_new)}`);
      if (data.query.field_course_type)
        queryParams.push(`field_course_type=${encodeURIComponent(data.query.field_course_type)}`);
      if (data.query.field_college_name)
        queryParams.push(`field_college_name=${encodeURIComponent(data.query.field_college_name)}`);
      if (data.query.field_website_page_visit)
        queryParams.push(
          `field_website_page_visit=${encodeURIComponent(data.query.field_website_page_visit)}`
        );

      if (queryParams.length > 0) {
        queryString += `?${queryParams.join('&')}`;
      }

      const userData = {
        ...user,
        profileId: {
          ...user?.profileId,
          userPreferences: {
            ...user?.profileId?.userPreferences,
            ...data?.userPreferences,
          },
        },
      };
      setUserDetails(userData);
      updateUserInLocalStorage(userData);
      // updating user preferences to penpencil.
      await AuthApi.updateUserDetails({ userPreferences: data.userPreferences });
      await sendEventToBackend(data.userPreferences, queryString);
    } catch (error: unknown) {
      // eslint-disable-next-line no-console
      console.error((error as IError)?.error);
      // setApiErrorMessage((error as IError)?.error || 'Something went wrong!');
      // setApiError(true);
    }
  };

  const handleDownload = async (data: IUserPreferences) => {
    // setLoading(true);
    if (ModalType.ONBOARDING === modalType) {
      setLoading(true);
    } else {
      setSaving(true);
      setDialogOpen(true);
    }

    // send lead on button click
    const leadData = {
      userPreferences: {
        ...data,
      },
      query: {
        source: utmQuery?.utm_source,
        medium: utmQuery?.utm_medium,
        campaign: utmQuery?.utm_campaign,
        enquiryType: enquiryTypeNPF,
        field_course_new: courseDetails && (courseDetails?.name || courseDetails?.title),
        field_course_type: courseDetails && courseDetails?.courseType,
        ...(pageName === 'course_page' && {
          field_course_new: courseDetails && (courseDetails?.name || courseDetails?.title),
        }),
        ...(modalType === ModalType.ONLINE_DEGREE && {
          field_course_new:
            courseName || (courseDetails && (courseDetails?.name || courseDetails?.title)),
        }),
        ...(modalType === ModalType.ONLINE_DEGREE && {
          field_course_type: 'online_degree',
          field_college_name:
            collegeName ||
            (courseDetails &&
              courseDetails?.partnerInstituteDetails &&
              courseDetails?.partnerInstituteDetails[0]?.name),
          field_website_page_visit: 'Online Degree',
        }),
      },
    };
    if (
      type === LeadType.DOWNLOAD_CURRICULUM ||
      type === LeadType.DOWNLOAD_PLACEMENT_REPORT ||
      type === LeadType.DOWNLOAD_BROCHURE
    ) {
      anchorRef?.current?.click();
    }
    setCount(AUTO_CLOSE_TIME / 1000);
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current); // Clear any existing timeout
    }
    timeoutRef.current = setTimeout(() => {
      closeModal();
      if (window && redirectLink) {
        setTimeout(() => {
          window.open(redirectLink, '_blank');
        }, 1000);
      }
    }, AUTO_CLOSE_TIME);
    if (redirectToDashboard) {
      setLoadingDashboarding(true);
      setTimeout(() => {
        goToDashoboard();
      }, 2000);
    }
    triggerSkFormSubmittedEvent(leadData.userPreferences);
    await sendLead(leadData);
  };

  const handleDownloadFile = () => {
    if (curriculumPdf || reportLink) {
      return (
        <a
          ref={anchorRef}
          href={curriculumPdf ? `${s3Url}/assets/uploads/curriculum/${curriculumPdf}` : reportLink}
          className="absolute bottom-0 hidden"
          download=""
        >
          &apos;&apos;
        </a>
      );
    }
    return undefined;
  };

  const handleSendLeadData = async (data: IUserPreferences) => {
    if (modalType !== ModalType.ONBOARDING) {
      setOpenOnboardingForm(false);
    }
    hasDownloadedRef.current = true;
    handleDownload(data);
  };

  const handleCloseModal = () => {
    if (openOnboardingForm) {
      setOpenOnboardingForm(false);
    }
  };

  useEffect(() => {
    let timer: NodeJS.Timer;

    if (saving && count > 0) {
      timer = setInterval(() => {
        setCount((prevCount) => prevCount - 1);
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [saving, count]);

  useEffect(() => {
    if (modalOpen && checkIfPresenceAlreadyFilled() && !hasDownloadedRef.current) {
      handleDownload(user?.profileId?.userPreferences);
    }
  }, [downloadDirectly]);

  useEffect(() => {
    if (courseDetails?._id) {
      // getIsCourseBought();
      setIsCourseBought(checkIsCourseBought(courseDetails?._id));
    }
  }, [courseDetails]);

  useEffect(() => {
    if (!openOnboardingForm || !showOnboardingForm || skFormStartedTrackedRef.current) return;

    const courseNameValue =
      courseName || courseDetails?.name || courseDetails?.title || categoryDetails?.title || '';
    const courseIdValue = courseId || courseDetails?._id || '';
    const courseCategoryValue =
      categoryName || courseDetails?.categoryDetails?.title || categoryDetails?.title || '';
    const cohortIdValue =
      typeof courseDetails?.cohortId === 'string'
        ? courseDetails?.cohortId
        : courseDetails?.cohortId?._id || '';
    const courseSlugValue = courseDetails?.slug || '';
    const priceValue = courseDetails?.pricing?.IN ?? courseDetails?.pricing?.US;
    const discountValue = courseDetails?.pricing?.discount;
    const isFreeValue = courseDetails?.pricing?.isFree;

    sendSkFormStartedEvent({
      userData: user,
      isLoggedIn,
      isUserPaid: isCourseBought,
      user_account_type: user?.userType,
      page_path: typeof window !== 'undefined' ? window.location.pathname : pageName || '',
      page_referrer_name: pageName || undefined,
      page_referrer_cta: type || enquiryType || 'onboarding_lead_form_start',
      page_referrer_widget_name: modalType || 'onboarding_lead_form_modal',
      user_pseudo_id: getUserPseudoId() || undefined,
      pw_user_id: user?._id,
      user_segment: isLoggedIn ? 'returning_user' : 'new',
      form_id: 'onboarding_lead_form',
      form_name: 'Onboarding Lead Form',
      form_type: 'lead',
      form_location: pageName || 'onboarding_lead_form',
      form_total_fields: 3,
      form_time_fill_sec: 0,
      course_batch_name: courseNameValue || undefined,
      course_batch_slug: courseSlugValue || undefined,
      course_batch_category: courseCategoryValue || undefined,
      course_batch_id: courseIdValue || undefined,
      course_batch_cohort_id: cohortIdValue || undefined,
      price: priceValue,
      discount_percentage: discountValue,
      is_free: isFreeValue,
    });

    skFormStartedTrackedRef.current = true;
  }, [
    courseDetails,
    categoryDetails?.title,
    categoryName,
    courseId,
    courseName,
    enquiryType,
    isCourseBought,
    isLoggedIn,
    modalType,
    openOnboardingForm,
    pageName,
    showOnboardingForm,
    type,
    user,
  ]);

  useEffect(() => {
    setShowOnboarding(false);
  }, []);

  return (
    <div>
      {/* for modal */}
      {openOnboardingForm && loadingDashboarding && (
        <Modal
          isOpen={openOnboardingForm}
          closeBtn={false}
          onClose={handleCloseModal}
          className="h-[100%] w-[100%] medium:h-[640px] medium:!w-[1080px] medium:rounded-3xl"
        >
          <CircleLoader />
        </Modal>
      )}
      {openOnboardingForm && showOnboardingForm && (
        <Modal
          isOpen={openOnboardingForm}
          closeBtn={false}
          onClose={handleCloseModal}
          className="h-[100%] w-[100%] medium:!h-[640px] medium:!w-[1024px] medium:rounded-3xl"
        >
          <OnboardingForm
            className="w-full h-full"
            handleSendLeadData={handleSendLeadData}
            loading={loading}
          />
        </Modal>
      )}
      {handleDownloadFile()}
      {modalType !== ModalType.ONBOARDING && (
        <Dialog
          open={dialogOpen}
          closeModal={closeModal}
          isOutSideClick
          className={`regular:!w-[90%] ${
            saving ? 'regular:!w-[412px] regular:!h-fit' : 'large:!w-1/2 !p-6 '
          } rounded`}
          titleWrapperClass="border-none !pb-0  !hidden"
        >
          {saving && modalType !== ModalType.ONBOARDING && (
            <Saving type={type} msgLineOne={msgLineOne} msgLineTwo={msgLineTwo} count={count} />
          )}
        </Dialog>
      )}
    </div>
  );
};

export default OnboardingLeadForm;
